export interface PropertyDetailGridViewProps {
  leftChildren: React.ReactNode;
  rightChildren: React.ReactNode;
}

export function PropertyDetailGridView({
  leftChildren,
  rightChildren,
}: PropertyDetailGridViewProps) {
  return (
    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-5">
      <div className="space-y-4 col-span-2">{leftChildren}</div>
      <div className="space-y-4 col-span-3">{rightChildren}</div>
    </div>
  );
}
